import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import TextInput from 'src/ui/library/TextInput';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
// import Popout from 'src/ui/library/Popout';
import intl from 'react-intl-universal';

/* Controls that can be used in TableFilter */
import DropdownControl from 'src/ui/library/Dropdown';
import DateControl from 'src/ui/library/DatePicker';
import TextControl from 'src/ui/library/TextInput';
import { fnGetCaseData } from '../../../../src/helpers/commonFunctions';
import ToolTip from '../ToolTip';

const FilterControls = {
  Dropdown: DropdownControl,
  Text: TextControl,
  Date: DateControl,
};

class TableFilter extends React.Component {
  static propTypes = {
    /** Classname to be applied to <TableFilter> */
    className: PropTypes.string,
    /** List of filters (controls) to be rendered */
    filters: PropTypes.PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        controlType: PropTypes.string.isRequired,
        /* any other keys passed in get passed as props to the Control */
      }),
    ).isRequired,
    /** Display filter action button */
    showFilter: PropTypes.bool,
    /** Display search field */
    showSearch: PropTypes.bool,
    /** Callback function for search onchange */
    onSearch: PropTypes.func,
    /** Callback function for 'Apply Click' */
    onClear: PropTypes.func,
    /** Callback function for 'Apply Click' */
    onApply: PropTypes.func,
    /** Callback function for control updates. fn(id: string, filterState: object) */
    onChange: PropTypes.func,
    /** Filter visibility state */
    isShowFilterOptions: PropTypes.bool,
    /** Functon to handle filter visibility */
    onFilter: PropTypes.func,

    resetNotApplicable: PropTypes.func,
    resetNotSure: PropTypes.func,
    notApplicable: PropTypes.bool,
    notSure: PropTypes.bool,
    showCheckbox: PropTypes.bool,
    isPageMandatory: PropTypes.bool,
    isRelatedEntity: PropTypes.bool,
  };

  static defaultProps = {
    filters: [],
    showFilter: true,
    showSearch: true,
    isShowFilterOptions: true,
    notApplicable: false,
    notSure: false,
    showCheckbox: false,
    isPageMandatory: false,
    isRelatedEntity: false,
  };

  state = {
    searchText: '',
    filters: {},
    announceText: '',
  };
  isOnLoadCalled = false;
  componentDidUpdate() {
    if (
      this.props.defaultSelectedFilters &&
      (this.state.counter || 0) <= 0 &&
      !this.isOnLoadCalled &&
      this.state.filters &&
      Object.keys(this.state.filters).length === 0
    ) {
      if (
        this.props.defaultSelectedFilters.type === 'NEW_DASHBOARD_REDIRECTED' ||
        this.props.defaultSelectedFilters.type === 'MESSAGE_REDIRECTED'
      ) {
        let { keys } = this.props.defaultSelectedFilters;
        if (keys && keys.length > 0) {
          let filtersObj = {};
          for (let index = 0; index < keys.length; index++) {
            if (keys[index].key === 'caseId') {
              filtersObj['caseId'] = keys[index].value;
            }
          }
          if (this.props.defaultSelectedFilters.type === 'MESSAGE_REDIRECTED') this.OnLoadApply(filtersObj, this.state.counter);
          else {
            if (this.props.isFilterLoaded && this.props.isFilterLoaded) {
              this.OnLoadApply(filtersObj, this.state.counter);
            }
          }
        }
      }
    }
  }

  handleOnChange = (id, event) => {
    // some controls are inconsistent. sometimes returning an event others the direct value
    const newValue = event && event.target ? event.target.value : event;
    const eventId = event && event.target ? event.target.id : undefined;

    if (id === 'hostCountry') {
      this.setState(prevState => ({ filters: { ...prevState.filters, applicationType: undefined } }));
    }
    this.setState(
      prevState => ({ filters: { ...prevState.filters, [id]: newValue } }),
      () => {
        if (this.props.onChange) {
          this.props.onChange(eventId, this.state.filters);
        }
      },
    );
  };

  getControls = config => {
    if (!config.length) return null;

    const controls = config.map((control, index) => {
      const ControlComponent = FilterControls[control.controlType];
      if (!ControlComponent) {
        return null;
      }

      const { controlType, id, ...otherProps } = control;
      let className = 'content-item';
      if (this.props.pageType === 'messaging' || this.props.pageType === 'document') {
        className += ' ' + (this.props.pageType === 'document' ? 'document_sc' : id);
      }
      return (
        <Grid key={id} item xs={12} sm={6} lg={fnGetCaseData() ? '4' : '3'} className={className} aria-label={otherProps.label}>
          <ControlComponent
            {...otherProps}
            id={id}
            onChange={event => this.handleOnChange(id, event)}
            label={otherProps.label}
            value={Object.keys(this.state.filters).length === 0 ? '' : this.state.filters[id]}
          />
        </Grid>
      );
    });

    return controls;
  };

  clearDefaultCaseId = key => {
    this.setState(prevState => {
      let prevStateObj = { ...prevState };
      if (prevStateObj.filters) {
        delete prevStateObj.filters['caseId'];
      }
      return prevState;
    });
  };

  handleClear = () => {
    if (this.props.onClear) {
      this.props.onClear(this.state.filters);
    }

    this.setState({ filters: {}, announceText: intl.get('table.labels.filtersCleared') });
  };
  OnLoadApply(filters) {
    if (this.props.onApply) {
      this.isOnLoadCalled = true;
      return Promise.resolve(
        this.setState({ announceText: intl.get('table.labels.selectedFiltersApplied'), filters: { ...filters }, isOnLoadCalled: true }),
      ).then(() => {
        this.props.onApply(this.state.filters);
      });
    }
  }

  handleApply = () => {
    if (this.props.onApply) {
      this.setState({ announceText: intl.get('table.labels.selectedFiltersApplied') });
      this.props.onApply(this.state.filters);
      // this.closePopout();
    }
  };

  handleSearch = event => {
    const newValue = event.target.value;
    this.setState(
      {
        searchText: newValue,
        announceText: intl.get('table.labels.showingResultsFor') + newValue || intl.get('table.labels.showingAllResults'),
      },
      () => {
        if (this.props.onSearch) {
          this.props.onSearch(newValue);
        }
      },
    );
  };

  render() {
    /** commented to address US587350 */
    /** const containerRef = React.createRef();
   
    const rootClass = classNames({
      'table-filter': true,
      'hide-search': !this.props.showSearch,
      'hide-filter': !this.props.showFilter,
    }); */

    return (
      <Fragment>
        {/** Popout commented to address US587350. Filter section will always be opened. */}
        {/* <div className={rootClass} ref={containerRef}>
            <Popout
              orientation={'right'}
              container={containerRef}
              useContainerWidth={true}
              hoverable={false}
              padding={0}
              triggerClose={fn => (this.closePopout = fn)}
              buttonName={intl.get('table.labels.ariaLabel')}
              trigger={
                <div className="filter-icon-container">
                  <FilterListIcon className="filter-icon" />
                  <span className="filter-text">{intl.get('table.labels.filter')}</span>
                </div>
              }
              content={
                <Grid container spacing={0} className="table-filter-content">
                  {this.getControls(this.props.filters)}
                  <Grid item lg={12} md={12} sm={12} xs={12} className="content-item content-actions">
                    <button className="filter-action-btn" onClick={this.handleApply}>
                      {intl.get('table.labels.apply')}
                    </button>
                    <button className="filter-action-btn" onClick={this.handleClear}>
                      {intl.get('table.labels.clear')}
                    </button>
                  </Grid>
                </Grid>
              }
            />
            <TextInput
              label={intl.get('table.labels.search')}
              className="search-field-container"
              value={this.state.searchText}
              inputProps={{ maxLength: 255 }}
              onChange={this.handleSearch}
              id="searchSSIText"
              styleType="tableFilter"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="search-icon">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            /> 
          </div> */}
        {/** Filter will alway opened. no toggole functionalities  , padma removed className="filter-container" as */}
        <div className="filter-container">
          <div className="search-container">
            {this.props.showFilter && (
              <div
                style={{
                  cursor: 'pointer',
                }}
                className="icon-container"
                onClick={this.props.onFilter}>
                <FilterListIcon className="filter-icon" />
                <span className="filter-text">{intl.get('table.labels.filter')}</span>
              </div>
            )}
            {this.props.showSearch && (
              <ToolTip hideButton={true} placement="bottom-start" popperClassName="d-none">
                <TextInput
                  label={
                    this.props.showCheckbox || this.props.isRelatedEntity
                      ? intl.get('table.labels.searchText')
                      : intl.get('table.labels.search')
                  }
                  className="search-field-container"
                  value={this.state.searchText}
                  inputProps={{ maxLength: 255 }}
                  onChange={this.handleSearch}
                  id="searchSSIText"
                  styleType="tableFilter"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className="search-icon">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </ToolTip>
            )}
          </div>
          {this.props.isShowFilterOptions
            ? this.props.showFilter && (
                <Grid container spacing={0} className="table-filter-content">
                  {this.getControls(this.props.filters)}
                  <Grid item lg={12} md={12} sm={12} xs={12} className="content-item content-actions">
                    <button className="filter-action-btn" onClick={this.handleApply}>
                      {intl.get('table.labels.apply')}
                    </button>
                    <button className="filter-action-btn" onClick={this.handleClear}>
                      {intl.get('table.labels.clear')}
                    </button>
                  </Grid>
                </Grid>
              )
            : null}
        </div>
        <div className="announce-message" aria-live="polite">
          {this.state.announceText}
        </div>
      </Fragment>
    );
  }
}

export default TableFilter;
